import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CB12HandheldIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M11,15.1V8.9H2.9C2.6,8.9,2.5,9,2.5,9.2v5.5c0,0.2,0.2,0.4,0.4,0.4H11z" />
        <path d="M21.1,15.1c0.2,0,0.4-0.2,0.4-0.4V9.2c0-0.2-0.2-0.4-0.4-0.4l-8.2,0v6.3H21.1z" />
        <path
          d="M21.1,17.6H2.9c-1.6,0-2.9-1.3-2.9-2.9V9.2c0-1.6,1.3-2.9,2.9-2.9h18.3c1.6,0,2.9,1.3,2.9,2.9v5.5
		C24,16.3,22.7,17.6,21.1,17.6z M21.1,16.5c1,0,1.8-0.8,1.8-1.8V9.2c0-1-0.8-1.8-1.8-1.8H2.9c-1,0-1.8,0.8-1.8,1.8v5.5
		c0,1,0.8,1.8,1.8,1.8H21.1z"
        />
      </g>
    </SvgIcon>
  );
};

export default CB12HandheldIcon;
